import React, { useState, useEffect, useRef } from "react";
import "../Styles/ScoreBoard.css";
import FarmHouseImg from "../assets/Header-Images/farmHouse.svg";
import GrassImg from "../assets/Header-Images/Group-Grass10.svg";

// Counter Component with Scroll Trigger
const Counter = ({ targetNumber, duration = 4000, startCounting }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!startCounting) return; // Start only when in view

    let start = 0;
    const increment = targetNumber / (duration / 16);
    const interval = setInterval(() => {
      start += increment;
      if (start >= targetNumber) {
        setCount(targetNumber);
        clearInterval(interval);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(interval);
  }, [targetNumber, duration, startCounting]);

  return <span>{count}</span>;
};

export default function Details() {
  const statsRef = useRef(null);
  const [startCounting, setStartCounting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounting(true);
        }
      },
      { threshold: 0.5 } // 50% of the section should be visible to trigger
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, []);

  return (
    <div className="agriculture-container">
      {/* Left green box - 710px × 443px */}
      <div className="stats-box" ref={statsRef}>
        <h2 className="stats-heading">Growing crops and raising livestock</h2>

        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-value">
              <Counter targetNumber={90} startCounting={startCounting} />+
            </div>
            <div className="stat-label">Products</div>
          </div>

          <div className="stat-item">
            <div className="stat-value">
              <Counter targetNumber={6} startCounting={startCounting} />+
            </div>
            <div className="stat-label">States</div>
          </div>

          <div className="stat-item">
            <div className="stat-value">
              <Counter targetNumber={500} startCounting={startCounting} />+
            </div>
            <div className="stat-label">Distributors</div>
          </div>

          <div className="stat-item">
            <div className="stat-value">
              <Counter targetNumber={28} startCounting={startCounting} />M
            </div>
            <div className="stat-label">Farmers</div>
          </div>
        </div>

        {/* Decorative grass element at the bottom */}
        <div className="grass-decoration">
          <img src={GrassImg} alt="Grass Decoration" className="grass-svg" />
        </div>
      </div>

      {/* Right image - 710px × 505px */}
      <div className="image-container">
        <img
          src={FarmHouseImg}
          alt="Agricultural facility with palm trees"
          className="farm-image"
        />
      </div>
    </div>
  );
}